{
  "name": "@T-system/eshop-client",
  "version": "3.4.276",
  "private": true,
  "author": "telmax.eu",
  "license": "UNLICENSED",
  "scripts": {
    "chooseHaulier": "ts-node -r tsconfig-paths/register ./scripts/chooseHaulier.ts",
    "link-common": "npm link @T-system/common",
    "link-ui-kit": "npm link @T-system/ui-kit",
    "licence-checker": "tf-licence-checker --config=licence-checker.config.cjs",
    "start": "node server.js",
    "dev": "cross-env NODE_OPTIONS='--experimental-require-module' vite",
    "build": "vue-tsc --noEmit && vite build",
    "build:test": "vue-tsc --noEmit && vite build --mode test",
    "lint": "vue-tsc --noEmit && eslint \"{src,scripts,tests}/**/*.{vue,js,ts}\" --quiet --max-warnings 86 && npm run env:manager:validate",
    "lint:fix": "vue-tsc && eslint \"{src,scripts,tests}/**/*.{vue,js,ts}\" --fix && npm run env:manager:validate",
    "test:unit": "vitest run --coverage",
    "test:e2e": "cypress open",
    "nyc:report": "nyc report --reporter=text --reporter=cobertura --reporter=lcov",
    "start:api": "cd api-server && npm run start-for-cypress-ci",
    "start:api:dev": "cd api-server && npm run dev:api",
    "start:client": "cross-env PORT=8080 node server.js",
    "start:client-and-api": "start-test start:api 3000 start:client",
    "test:run": "cypress run --spec tests/e2e/specs/$CI_JOB_NAME_SANITIZED/*.cy.ts,tests/e2e/specs/$CI_JOB_NAME_SANITIZED/**/*.cy.ts",
    "test:ci": "start-server-and-test start:client-and-api 8080 \"cypress run --spec tests/e2e/specs/$CI_JOB_NAME_SANITIZED/*.cy.ts,tests/e2e/specs/$CI_JOB_NAME_SANITIZED/**/*.cy.ts --headless --browser=chrome\"",
    "test:e2e:accessibility": "cypress run --spec tests/e2e/specs/test-accessibility/**/*",
    "start:api:generate:ci": "start-server-and-test start:api 3000 api:generate:ci",
    "api:generate": "curl -o api-definition.json http://localhost:3000/api/api-definition && cross-env LANG=en_US.UTF-8 openapi-ts",
    "api:generate:ci": "curl -o api-definition.json http://127.0.0.1:3000/api/api-definition && cross-env LANG=en_US.UTF-8 openapi-ts",
    "eslint": "eslint \"{src,scripts,tests}/**/*.{vue,js,ts}\"",
    "env:manager": "t-system-env-manager",
    "env:manager:validate": "t-system-env-manager --validate"
  },
  "engines": {
    "node": ">=24.11.1",
    "npm": ">=11.6.2"
  },
  "dependencies": {
    "@sentry/vue": "^10.45.0",
    "@T-system/common": "^6.0.14",
    "@T-system/ui-kit": "^2.0.19",
    "cross-env": "^10.1.0",
    "date-fns": "^4.1.0",
    "express": "^5.2.1",
    "express-basic-auth": "^1.2.1",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.23",
    "pinia": "^3.0.4",
    "pinia-plugin-persistedstate": "^4.7.1",
    "validator": "^13.15.26",
    "vue": "^3.5.30",
    "vue-cropperjs": "^5.0.0",
    "vue-i18n": "^11.3.0",
    "vue-router": "^5.0.4",
    "vue3-google-login": "^2.0.37",
    "vuetify": "^3.12.3"
  },
  "devDependencies": {
    "@cypress/code-coverage": "^4.0.2",
    "@eslint/js": "^10.0.1",
    "@hey-api/openapi-ts": "^0.89.2",
    "@mdi/font": "^7.4.47",
    "@types/facebook-js-sdk": "^3.3.12",
    "@types/lodash": "^4.17.24",
    "@types/node": "^24.11.1",
    "@types/validator": "^13.15.10",
    "@types/vue-cropperjs": "^4.1.6",
    "@vitejs/plugin-vue": "^6.0.5",
    "@vitest/coverage-v8": "^4.1.0",
    "@vue/eslint-config-typescript": "^14.7.0",
    "autoprefixer": "^10.4.27",
    "cy-verify-downloads": "^0.3.0",
    "cypress": "^15.12.0",
    "cypress-terminal-report": "^7.3.3",
    "eslint": "^10.1.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-cypress": "^6.2.0",
    "eslint-plugin-prettier": "^5.5.5",
    "eslint-plugin-vue": "^10.8.0",
    "eslint-plugin-vuetify": "^2.7.2",
    "globals": "^17.4.0",
    "jiti": "^2.6.1",
    "nyc": "^18.0.0",
    "prompts": "^2.4.2",
    "sass": "^1.98.0",
    "start-server-and-test": "^2.1.5",
    "tf-licence-checker": "^1.1.9",
    "ts-node": "^10.9.2",
    "tsconfig-paths": "^4.2.0",
    "typescript": "^5.9.3",
    "vite": "^8.0.1",
    "vite-plugin-istanbul": "^8.0.0",
    "vite-plugin-static-copy": "^3.3.0",
    "vite-plugin-vuetify": "^2.1.3",
    "vitest": "^4.1.0",
    "vue-eslint-parser": "^10.4.0",
    "vue-tsc": "^3.2.6",
    "wick-a11y": "^3.0.1"
  }
}
